// extracted by mini-css-extract-plugin
module.exports = {"prefix":"WorkspaceRoleName_prefix_2GHFv"};